import React from 'react';
import { Button } from 'primereact/button';
import { useLanguage } from '../../contexts/LanguageContext';
import useBlockShelfSeqItemDescription from './hooks/useBlockShelfSeqItemDescription';
import BlockShelfSeqItemDescriptionForm from './components/BlockShelfSeqItemDescriptionForm';
import BlockShelfSeqItemDescriptionTable from './components/BlockShelfSeqItemDescriptionTable';
import GenericFileExportButton from '../../components/common/GenericFileExportButton';
import { useLazyExportBlockShelfSeqItemDescriptionsToExcelQuery } from '../../api/endpoints/itemDescriptions';

const extractFileName = (result) =>
    result?.fileName || 'Raf Tanımlamaları.xlsx';

const extractData = (result) => result?.fileBase64;

const extractContentType = (result) => result?.contentType;

const BlockShelfSeqItemDescriptionPage = () => {
    const { th } = useLanguage();

    const {
        items,
        totalRecords,
        isLoading,
        isCreating,
        isUpdating,
        isDeleting,
        dialogVisible,
        selectedItem,
        page,
        pageSize,
        sortField,
        sortOrder,
        activeFilters,
        handlePage,
        onSort,
        handleApplyFilters,
        handleResetFilters,
        handleNew,
        handleEdit,
        handleSave,
        handleDelete,
        handleCloseDialog,
        exportParams
    } = useBlockShelfSeqItemDescription();

    return (
        <div className="card">
            <div className="flex justify-content-between align-items-center mb-4">
                <h1 className="m-0">
                    {th('blockShelfSeqItemDescription.pageTitle') || 'Raf Tanımlamaları'}
                </h1>

                <div className="flex gap-2">
                    <Button
                        icon="pi pi-filter-slash"
                        className="p-button-outlined p-button-secondary"
                        onClick={handleResetFilters}
                        tooltip={th('filter.reset') || 'Filtreleri Temizle'}
                        tooltipOptions={{ position: 'left' }}
                    />

                    <GenericFileExportButton
                        useExportQuery={useLazyExportBlockShelfSeqItemDescriptionsToExcelQuery}
                        exportParams={exportParams}
                        buttonLabel="Excel"
                        buttonClassName="p-button-success"
                        icon="pi pi-file-excel"
                        fileNameExtractor={extractFileName}
                        dataExtractor={extractData}
                        contentTypeExtractor={extractContentType}
                    />

                    <Button
                        label={th('blockShelfSeqItemDescription.newItem') || 'Raf Ekle'}
                        icon="pi pi-plus"
                        onClick={handleNew}
                    />
                </div>
            </div>

            <BlockShelfSeqItemDescriptionTable
                items={items}
                totalCount={totalRecords}
                loading={isLoading}
                lazyParams={{
                    first: (page - 1) * pageSize,
                    rows: pageSize,
                    page
                }}
                activeFilters={activeFilters}
                onFiltersChange={handleApplyFilters}
                sortField={sortField}
                sortOrder={sortOrder}
                onSortChange={onSort}
                onPage={handlePage}
                onEdit={handleEdit}
            />

            {dialogVisible && (
                <BlockShelfSeqItemDescriptionForm
                    visible={dialogVisible}
                    onHide={handleCloseDialog}
                    onSubmit={handleSave}
                    initialData={selectedItem}
                    isLoading={isCreating || isUpdating || isDeleting}
                    onDelete={handleDelete}
                />
            )}
        </div>
    );
};

export default BlockShelfSeqItemDescriptionPage;